import { getCustomers } from "@/services";
import { rejectPromise } from "@/utils";

/**
 * State of the module
 */
const state = {
  customers: [],
};

/**
 * Mutations constants
 */
const SET_CUSTOMERS = "SET_CUSTOMERS";

/**
 *  Mutations
 */
const mutations = {
  /**
   * SET_CUSTOMERS
   * @description list of customers
   */
  [SET_CUSTOMERS](state, data) {
    state.customers = data;
  },
};

/**
 *  Actions of the customer module
 */
const actions = {
  /**
   * Fetches customers list
   */
  async getCustomers({ commit }, params) {
    try {
      let { data } = await getCustomers(params);

      data = data ?? [];
      commit(SET_CUSTOMERS, data);
    } catch (error) {
      rejectPromise(error);
    }
  },
};

const getters = {
  customers({ customers }) {
    return customers;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
